<template>
  <div class="detail-affiliate-commission">
    <div class="margin-top">
      <el-table
        :data="affiliateCommissionManages"
        border
        style="width: 100%"
        v-loading="loading">
        <el-table-column
          prop="auName"
          :label="$t('affiliate.distributorName')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="orderId"
          :label="$t('affiliate.relatedOrderId')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="orderItemId"
          :label="$t('affiliate.orderItemId')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="userName"
          :label="$t('affiliate.orderUserName')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="relationLevel"
          :label="$t('affiliate.relationLevel')"
          align="center">
          <template slot-scope="scope">
            {{ _level(scope.row.relationLevel) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="commissionRate"
          :label="$t('affiliate.commissionRate')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="orderAmount"
          :label="$t('affiliate.orderAmount')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="commissionAmount"
          :label="$t('affiliate.commissionAmount')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="state"
          :label="$t('affiliate.orderStatus')"
          align="center">
          <template slot-scope="scope">
            {{ _state(scope.row.state) }}
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { listAffiliateCommission } from '@/api/affiliate/affiliateCommissionApi'

export default {
  name: 'DetailAffiliateCommission',
  data() {
    return {
      loading: false,
      affiliateCommissionManages: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      auId: ''
    }
  },
  methods: {
    loadData(params) {
      this.auId = params.auId
      this.getList()
    },
    async getList() {
      this.loading = true
      try {
        const res = await listAffiliateCommission({
          auIdContain2Level: this.auId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        })
        this.affiliateCommissionManages = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取分销订单列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    _level(state) {
      if (state === "1") {
        return this.$t('affiliate.firstLevel')
      }
      if (state === "2") {
        return this.$t('affiliate.secondLevel')
      }
      return ''
    },
    _state(state) {
      if (state === "0") {
        return this.$t('affiliate.pendingSettlement')
      }
      if (state === "1") {
        return this.$t('affiliate.settled')
      }
      if (state === "2") {
        return this.$t('affiliate.canceled')
      }
      return ''
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>